import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { BrowserRouter } from 'react-router'
import { registerSW } from 'virtual:pwa-register'

let showReload = false
const updateSW = registerSW({
  onNeedRefresh() {
    showReload = true
  },
  onOfflineReady() {},
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App updateSW={updateSW} showReload={showReload} />
    </BrowserRouter>
  </StrictMode>
)
